function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M9.042 4.805h.018a.996.996 0 01.428.126l.012.007.02.012c.021.012.041.026.06.04l-.08-.052a1.008 1.008 0 01.35.34l.016.026 3 5.196.015.027c.01.019.02.038.028.057l-.043-.084A1.008 1.008 0 0113 11v.022c0 .02-.002.04-.003.058L13 11a1.009 1.009 0 01-.27.684 1.52 1.52 0 01-.115.105.934.934 0 01-.095.066l-.02.011-.03.017a.996.996 0 01-.058.028l.088-.045a1.009 1.009 0 01-.473.134H5.974a.996.996 0 01-.074-.005L6 12a1.009 1.009 0 01-.473-.119l-.027-.015-.02-.011a1.001 1.001 0 01-.043-.028l.063.039a1.009 1.009 0 01-.458-.577 1.795 1.795 0 01-.025-.104A1.253 1.253 0 015 11.01v-.033c0-.023.002-.046.004-.07L5 11a1.008 1.008 0 01.126-.487l.008-.013 3-5.196.014-.024a.996.996 0 01.035-.054l-.049.078a1.008 1.008 0 01.355-.36l.011-.006a.99.99 0 01.077-.04l-.077.04a1.009 1.009 0 01.5-.134h.042zM10.268 10L9 7.804 7.732 10h2.536z",
  fill: "currentColor",
  fillRule: "evenodd"
});

var SvgMicro = function SvgMicro(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 18,
      height: 18
    }, props), _ref)
  );
};

export default SvgMicro;